export const lotteryAbi = [
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': '_randomNumberProvider',
                'type': 'address'
            },
            {
                'internalType': 'address',
                'name': '_rewardsVault',
                'type': 'address'
            },
            {
                'internalType': 'address',
                'name': 'wrappedTokenAddress',
                'type': 'address'
            },
            {
                'internalType': 'address',
                'name': 'wrapperAddress',
                'type': 'address'
            },
            {
                'internalType': 'address',
                'name': 'parentGameFundsManager',
                'type': 'address'
            }
        ],
        'stateMutability': 'nonpayable',
        'type': 'constructor'
    },
    {
        'stateMutability': 'payable',
        'type': 'receive'
    },
    {
        'inputs': [],
        'name': 'balances',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'uint256',
                        'name': 'operations',
                        'type': 'uint256'
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'rewards',
                        'type': 'uint256'
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'nextPot',
                        'type': 'uint256'
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'pot',
                        'type': 'uint256'
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'contributors',
                        'type': 'uint256'
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'parentGame',
                        'type': 'uint256'
                    }
                ],
                'internalType': 'struct BalanceAllocations',
                'name': '',
                'type': 'tuple'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'blockPotToken',
        'outputs': [
            {
                'internalType': 'contract BlockpotToken',
                'name': '',
                'type': 'address'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'chanceOfWinner',
        'outputs': [
            {
                'internalType': 'uint24',
                'name': '',
                'type': 'uint24'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'configManager',
        'outputs': [
            {
                'internalType': 'contract IBlockpotConfigProvider',
                'name': '',
                'type': 'address'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'bytes32',
                'name': 'referralCode',
                'type': 'bytes32'
            }
        ],
        'name': 'createReferralCode',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'currentBlockpotConfig',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'uint256',
                        'name': 'minimumEntryAmount',
                        'type': 'uint256'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'bptDiscount',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'referralDiscount',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'minStakeTime',
                        'type': 'uint48'
                    }
                ],
                'internalType': 'struct BlockpotConfig',
                'name': '',
                'type': 'tuple'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'currentGameConfig',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'uint48',
                        'name': 'timeBetweenRounds',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'chanceIncrementAmount',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'chanceMultiplierAmount',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'chanceInitialAmount',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'maxProbability',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'rewardsPercentage',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'operationsPercentage',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'nextPotPercentage',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'parentGamePercentage',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'bool',
                        'name': 'hasParent',
                        'type': 'bool'
                    },
                    {
                        'internalType': 'bool',
                        'name': 'ignoreOdds',
                        'type': 'bool'
                    },
                    {
                        'internalType': 'uint24[]',
                        'name': 'numAllocs',
                        'type': 'uint24[]'
                    }
                ],
                'internalType': 'struct GameConfig',
                'name': '',
                'type': 'tuple'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'currentPots',
        'outputs': [
            {
                'internalType': 'uint256[]',
                'name': '',
                'type': 'uint256[]'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'currentRoundIndex',
        'outputs': [
            {
                'internalType': 'uint32',
                'name': '',
                'type': 'uint32'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'discounts',
        'outputs': [
            {
                'internalType': 'uint24',
                'name': 'bptDiscount',
                'type': 'uint24'
            },
            {
                'internalType': 'uint24',
                'name': 'referralDiscount',
                'type': 'uint24'
            },
            {
                'internalType': 'uint24',
                'name': 'denominator',
                'type': 'uint24'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'drawNumbers',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'drawNumbersOperationsRewards',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'roundIndex',
                'type': 'uint32'
            },
            {
                'internalType': 'uint16',
                'name': 'amount',
                'type': 'uint16'
            },
            {
                'internalType': 'bool',
                'name': 'redeemBpt',
                'type': 'bool'
            },
            {
                'internalType': 'bytes32',
                'name': 'promoCode',
                'type': 'bytes32'
            },
            {
                'internalType': 'bool',
                'name': 'payoutInWeth',
                'type': 'bool'
            },
            {
                'internalType': 'address',
                'name': 'frontend',
                'type': 'address'
            }
        ],
        'name': 'enter',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'address payable',
                        'name': 'beneficiary',
                        'type': 'address'
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'entryStart',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'uint16',
                        'name': 'amount',
                        'type': 'uint16'
                    },
                    {
                        'internalType': 'bool',
                        'name': 'payoutInWeth',
                        'type': 'bool'
                    }
                ],
                'internalType': 'struct LotteryEntry',
                'name': '',
                'type': 'tuple'
            }
        ],
        'stateMutability': 'payable',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'roundIndex',
                'type': 'uint32'
            },
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'benefactor',
                        'type': 'address'
                    },
                    {
                        'internalType': 'address',
                        'name': 'beneficiary',
                        'type': 'address'
                    }
                ],
                'internalType': 'struct EntryAddresses',
                'name': 'addresses',
                'type': 'tuple'
            },
            {
                'internalType': 'uint16',
                'name': 'amount',
                'type': 'uint16'
            },
            {
                'internalType': 'bool',
                'name': 'redeemBpt',
                'type': 'bool'
            },
            {
                'internalType': 'bytes32',
                'name': 'promoCode',
                'type': 'bytes32'
            },
            {
                'internalType': 'bool',
                'name': 'payoutInWeth',
                'type': 'bool'
            },
            {
                'internalType': 'address',
                'name': 'frontend',
                'type': 'address'
            }
        ],
        'name': 'enterFor',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'address payable',
                        'name': 'beneficiary',
                        'type': 'address'
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'entryStart',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'uint16',
                        'name': 'amount',
                        'type': 'uint16'
                    },
                    {
                        'internalType': 'bool',
                        'name': 'payoutInWeth',
                        'type': 'bool'
                    }
                ],
                'internalType': 'struct LotteryEntry',
                'name': '',
                'type': 'tuple'
            }
        ],
        'stateMutability': 'payable',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'roundIndex',
                'type': 'uint32'
            },
            {
                'internalType': 'uint16',
                'name': 'amount',
                'type': 'uint16'
            },
            {
                'internalType': 'bool',
                'name': 'redeemBpt',
                'type': 'bool'
            },
            {
                'internalType': 'bytes32',
                'name': 'promoCode',
                'type': 'bytes32'
            },
            {
                'internalType': 'bool',
                'name': 'payoutInWeth',
                'type': 'bool'
            },
            {
                'internalType': 'address',
                'name': 'frontend',
                'type': 'address'
            }
        ],
        'name': 'enterWeth',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'address payable',
                        'name': 'beneficiary',
                        'type': 'address'
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'entryStart',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'uint16',
                        'name': 'amount',
                        'type': 'uint16'
                    },
                    {
                        'internalType': 'bool',
                        'name': 'payoutInWeth',
                        'type': 'bool'
                    }
                ],
                'internalType': 'struct LotteryEntry',
                'name': '',
                'type': 'tuple'
            }
        ],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'roundIndex',
                'type': 'uint32'
            },
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'benefactor',
                        'type': 'address'
                    },
                    {
                        'internalType': 'address',
                        'name': 'beneficiary',
                        'type': 'address'
                    }
                ],
                'internalType': 'struct EntryAddresses',
                'name': 'addresses',
                'type': 'tuple'
            },
            {
                'internalType': 'uint16',
                'name': 'amount',
                'type': 'uint16'
            },
            {
                'internalType': 'bool',
                'name': 'redeemBpt',
                'type': 'bool'
            },
            {
                'internalType': 'bytes32',
                'name': 'promoCode',
                'type': 'bytes32'
            },
            {
                'internalType': 'bool',
                'name': 'payoutInWeth',
                'type': 'bool'
            },
            {
                'internalType': 'address',
                'name': 'frontend',
                'type': 'address'
            }
        ],
        'name': 'enterWethFor',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'address payable',
                        'name': 'beneficiary',
                        'type': 'address'
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'entryStart',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'uint16',
                        'name': 'amount',
                        'type': 'uint16'
                    },
                    {
                        'internalType': 'bool',
                        'name': 'payoutInWeth',
                        'type': 'bool'
                    }
                ],
                'internalType': 'struct LotteryEntry',
                'name': '',
                'type': 'tuple'
            }
        ],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'roundIndex',
                'type': 'uint32'
            },
            {
                'internalType': 'address',
                'name': 'beneficiary',
                'type': 'address'
            }
        ],
        'name': 'entriesForBeneficiary',
        'outputs': [
            {
                'internalType': 'uint48[]',
                'name': '',
                'type': 'uint48[]'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'roundIndex',
                'type': 'uint32'
            },
            {
                'internalType': 'address',
                'name': 'player',
                'type': 'address'
            }
        ],
        'name': 'entriesForPlayer',
        'outputs': [
            {
                'internalType': 'uint48[]',
                'name': '',
                'type': 'uint48[]'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'entryAmount',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint16',
                'name': 'amount',
                'type': 'uint16'
            },
            {
                'internalType': 'address',
                'name': 'benefactor',
                'type': 'address'
            },
            {
                'internalType': 'bool',
                'name': 'blockPotRedemptionDiscount',
                'type': 'bool'
            }
        ],
        'name': 'entryQuote',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'feeAllocations',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'uint256',
                        'name': 'operations',
                        'type': 'uint256'
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'rewards',
                        'type': 'uint256'
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'nextPot',
                        'type': 'uint256'
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'parentGame',
                        'type': 'uint256'
                    }
                ],
                'internalType': 'struct FeeAllocations',
                'name': '',
                'type': 'tuple'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'roundIndex',
                'type': 'uint32'
            }
        ],
        'name': 'finalizeRound',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address'
            }
        ],
        'name': 'frontendPayouts',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'name': 'frontends',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'frontendsLength',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'fundsManager',
        'outputs': [
            {
                'internalType': 'contract BlockpotFundsManager',
                'name': '',
                'type': 'address'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint48',
                'name': 'entryIndex',
                'type': 'uint48'
            },
            {
                'internalType': 'uint32',
                'name': 'roundIndex',
                'type': 'uint32'
            }
        ],
        'name': 'getEntry',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'address payable',
                        'name': 'beneficiary',
                        'type': 'address'
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'entryStart',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'uint16',
                        'name': 'amount',
                        'type': 'uint16'
                    },
                    {
                        'internalType': 'bool',
                        'name': 'payoutInWeth',
                        'type': 'bool'
                    }
                ],
                'internalType': 'struct LotteryEntry',
                'name': '',
                'type': 'tuple'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'roundIndex',
                'type': 'uint32'
            }
        ],
        'name': 'getMaxNumberForRound',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': '',
                'type': 'uint48'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'getNextDrawTime',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': '_account',
                'type': 'address'
            }
        ],
        'name': 'getReferralCode',
        'outputs': [
            {
                'internalType': 'bytes32',
                'name': '',
                'type': 'bytes32'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'roundIndex',
                'type': 'uint32'
            }
        ],
        'name': 'getRemainingEntriesNeededForDrawing',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': '',
                'type': 'uint48'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'roundIndex',
                'type': 'uint32'
            }
        ],
        'name': 'getRoundData',
        'outputs': [
            {
                'components': [
                    {
                        'components': [
                            {
                                'internalType': 'uint256',
                                'name': 'prize',
                                'type': 'uint256'
                            },
                            {
                                'internalType': 'address payable',
                                'name': 'winner',
                                'type': 'address'
                            },
                            {
                                'internalType': 'uint48',
                                'name': 'number',
                                'type': 'uint48'
                            }
                        ],
                        'internalType': 'struct DrawnNumber[]',
                        'name': 'draws',
                        'type': 'tuple[]'
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'prizePool',
                        'type': 'uint256'
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'drawTime',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'entryCount',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'uint32',
                        'name': 'potIndex',
                        'type': 'uint32'
                    },
                    {
                        'internalType': 'uint16',
                        'name': 'roundIndexInPot',
                        'type': 'uint16'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'chance',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'enum RoundStatus',
                        'name': 'status',
                        'type': 'uint8'
                    },
                    {
                        'internalType': 'address',
                        'name': 'numberDrawInitiator',
                        'type': 'address'
                    },
                    {
                        'internalType': 'address',
                        'name': 'finalizeRoundInitiator',
                        'type': 'address'
                    }
                ],
                'internalType': 'struct LotteryRound',
                'name': '',
                'type': 'tuple'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'getTimeBetweenRounds',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': '',
                'type': 'uint48'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': '_blockPotToken',
                'type': 'address'
            },
            {
                'internalType': 'address',
                'name': '_configManager',
                'type': 'address'
            },
            {
                'internalType': 'address',
                'name': '_rewardTracker',
                'type': 'address'
            },
            {
                'internalType': 'address',
                'name': '_referralManager',
                'type': 'address'
            },
            {
                'internalType': 'address',
                'name': '_contributorsRewardTracker',
                'type': 'address'
            },
            {
                'internalType': 'address',
                'name': '_contributorsRewardsVault',
                'type': 'address'
            },
            {
                'internalType': 'address',
                'name': '_wethAddress',
                'type': 'address'
            },
            {
                'internalType': 'address',
                'name': '_rewardLostAndFound',
                'type': 'address'
            },
            {
                'internalType': 'uint256',
                'name': 'entryThreshold',
                'type': 'uint256'
            }
        ],
        'name': 'initialize',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'isAcceptingEntries',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'isDrawingNumbers',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'lastEntryEnd',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': '',
                'type': 'uint48'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'roundIndex',
                'type': 'uint32'
            }
        ],
        'name': 'lastEntryEndForRound',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': '',
                'type': 'uint48'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'numbersToDraw',
        'outputs': [
            {
                'internalType': 'uint8',
                'name': '',
                'type': 'uint8'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'owner',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'randomNumberProvider',
        'outputs': [
            {
                'internalType': 'contract LotteryRandomNumberProvider',
                'name': '',
                'type': 'address'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint48[]',
                'name': 'drawnNumbers',
                'type': 'uint48[]'
            },
            {
                'internalType': 'uint32',
                'name': 'drawnForRoundIndex',
                'type': 'uint32'
            },
            {
                'internalType': 'address',
                'name': 'initiator',
                'type': 'address'
            }
        ],
        'name': 'receiveDrawnNumbers',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'referralManager',
        'outputs': [
            {
                'internalType': 'contract BlockpotReferralManager',
                'name': '',
                'type': 'address'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address'
            }
        ],
        'name': 'referrerPayouts',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'name': 'referrers',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'referrersLength',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'renounceOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'rewardTracker',
        'outputs': [
            {
                'internalType': 'contract BlockpotRewardTracker',
                'name': '',
                'type': 'address'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'name': 'rnds',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': 'prizePool',
                'type': 'uint256'
            },
            {
                'internalType': 'uint48',
                'name': 'drawTime',
                'type': 'uint48'
            },
            {
                'internalType': 'uint48',
                'name': 'entryCount',
                'type': 'uint48'
            },
            {
                'internalType': 'uint32',
                'name': 'potIndex',
                'type': 'uint32'
            },
            {
                'internalType': 'uint16',
                'name': 'roundIndexInPot',
                'type': 'uint16'
            },
            {
                'internalType': 'uint24',
                'name': 'chance',
                'type': 'uint24'
            },
            {
                'internalType': 'enum RoundStatus',
                'name': 'status',
                'type': 'uint8'
            },
            {
                'internalType': 'address',
                'name': 'numberDrawInitiator',
                'type': 'address'
            },
            {
                'internalType': 'address',
                'name': 'finalizeRoundInitiator',
                'type': 'address'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address'
            }
        ],
        'name': 'transferOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'winnerTierAllocations',
        'outputs': [
            {
                'internalType': 'uint24[]',
                'name': '',
                'type': 'uint24[]'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint32',
                'name': 'roundNumber',
                'type': 'uint32'
            }
        ],
        'name': 'LotteryDrawingNumbers',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'uint32',
                'name': 'roundIndex',
                'type': 'uint32'
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'initiator',
                'type': 'address'
            }
        ],
        'name': 'LotteryDrawnNumbersReceived',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint32',
                'name': 'roundNumber',
                'type': 'uint32'
            }
        ],
        'name': 'LotteryNoWinner',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'address',
                'name': 'player',
                'type': 'address'
            },
            {
                'indexed': false,
                'internalType': 'uint48',
                'name': 'entryCount',
                'type': 'uint48'
            },
            {
                'indexed': false,
                'internalType': 'uint48',
                'name': 'totalEntryCount',
                'type': 'uint48'
            }
        ],
        'name': 'LotteryOnEntry',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint32',
                'name': 'roundNumber',
                'type': 'uint32'
            },
            {
                'indexed': false,
                'internalType': 'address',
                'name': 'winnerAddress',
                'type': 'address'
            },
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'winningNumber',
                'type': 'uint256'
            },
            {
                'indexed': false,
                'internalType': 'uint8',
                'name': 'place',
                'type': 'uint8'
            }
        ],
        'name': 'LotteryWinnerSelected',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'previousOwner',
                'type': 'address'
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address'
            }
        ],
        'name': 'OwnershipTransferred',
        'type': 'event'
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'currentPot',
                'type': 'uint256'
            },
            {
                'internalType': 'uint256',
                'name': 'threshold',
                'type': 'uint256'
            }
        ],
        'name': 'ActivationThresholdNotMet',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'AlreadyDrawingNumbers',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'AlreadyInitialized',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'CannotEnterWhileDrawingNumbers',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'DrawTimeNotReached',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'uint16',
                'name': 'amount',
                'type': 'uint16'
            },
            {
                'internalType': 'uint16',
                'name': 'maxAmount',
                'type': 'uint16'
            }
        ],
        'name': 'EntryAmountTooLarge',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'EntryIndexOutOfBounds',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'EntryPaddingOverflow',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'FinalizingWrongRound',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'FundsTransferFailed',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'InsufficientAmountForPurchase',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'InsufficientBPTBalance',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'uint48',
                'name': 'currentMaxNumber',
                'type': 'uint48'
            },
            {
                'internalType': 'uint48',
                'name': 'requiredMaxNumber',
                'type': 'uint48'
            },
            {
                'internalType': 'uint8',
                'name': 'numbersToDraw',
                'type': 'uint8'
            }
        ],
        'name': 'InsufficientEntriesForDrawing',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'InsufficientOperationsFundsFunds',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'addr',
                'type': 'address'
            }
        ],
        'name': 'InvalidAddress',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'InvalidFrontendAddress',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'NoEntriesInRound',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'NotRandomNumberProvider',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'OperationsPayoutBelowThreshold',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address'
            }
        ],
        'name': 'OwnableInvalidOwner',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address'
            }
        ],
        'name': 'OwnableUnauthorizedAccount',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'PickedForWrongRound',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'ReentrancyGuardReentrantCall',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'RoundAlreadyReceivedDrawnNumbers',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'RoundIndexOutOfBounds',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'RoundNotReadyToBeFinalized',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'router',
                'type': 'address'
            },
            {
                'internalType': 'uint256',
                'name': 'amount',
                'type': 'uint256'
            }
        ],
        'name': 'RouterCallFailed',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'token',
                'type': 'address'
            }
        ],
        'name': 'SafeERC20FailedOperation',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'UnauthorizedEthTransfer',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'provided',
                'type': 'uint32'
            },
            {
                'internalType': 'uint32',
                'name': 'expected',
                'type': 'uint32'
            }
        ],
        'name': 'WrongRoundIndex',
        'type': 'error'
    }
] as const